import React from 'react';

import analyticsTrack from '@lib/analytics/analyticsTrack';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import { Elements, RichText } from 'prismic-reactjs';
import { useMaxBreakpoint } from '@hooks/useMediaQuery/useMediaQuery';
import styles from './RaisonDetre.module.scss';
import { IRaisonDetre } from '../../model/prismic';

const RaisonDetre = ({
  title,
  subtitle,
  description,
  showSection
}: IRaisonDetre) => {
  const theme = useTheme();

  const isMobile = useMaxBreakpoint('desktop');

  return (
    <>
      {showSection && (
        <section className={classNames(
          styles.RaisonDetre,
          theme.styles.Section,
          theme.styles.Tint1
        )}
        >
          <RichText
            render={title}
            htmlSerializer={(type, element, content, children, key) => {
              switch (type) {
                case Elements.heading1:
                  return (
                    <h2
                      key={key}
                      className={classNames(
                        theme.styles.Header,
                        styles.Title,
                        { [theme.styles.Core4]: isMobile }
                      )}
                    >
                      {children}
                    </h2>
                  );
                default:
                  return null;
              }
            }}
          />
          <p className={
            classNames({ [theme.styles.Core4]: isMobile }, styles.Subtitle)
          }
          >
            {subtitle}
          </p>

          <h3 className={
            classNames(
              theme.styles.Title2,
              styles.Description,
              { [theme.styles.Core4]: isMobile }
            )
            }
          >
            {description}
          </h3>

          <a
            role="button"
            href="/interior-design-style-quiz"
            className={classNames(theme.styles.Button, theme.styles.Primary)}
            onClick={() => analyticsTrack('cta_clicked', {
              title: `Shop Landing Page | Raison D'etre | ${title}`,
              subtitle,
              description,
              ctaLabel: 'Find your style'
            })}
          >
            FIND YOUR STYLE
          </a>
        </section>
      )}
    </>
  );
};

export default RaisonDetre;
